var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{style:({color: _vm.iconColor, fontSize: '40px'})},[_vm._v("⚆")])}
var staticRenderFns = []

export { render, staticRenderFns }